import { render, staticRenderFns } from "./competitive.vue?vue&type=template&id=7c1d4dff&"
import script from "./competitive.vue?vue&type=script&lang=js&"
export * from "./competitive.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports